import {createReducer} from '@reduxjs/toolkit'
import {AnyAction} from 'redux'
import {GET_CHECKOUT_OPTIONS_OLD, getCheckoutOptions} from '../actions/checkout-options'
import {CheckoutOptionsState} from '../types/state'

const defaultState: CheckoutOptionsState = {
  loaded: false,
  options: {
    premiumServices: true,
    paymentMethodConfigured: true,
    acceptCoupons: true,
    acceptGiftCards: true,
  },
}

export const checkoutOptions = createReducer(defaultState, builder => {
  builder
    .addCase(GET_CHECKOUT_OPTIONS_OLD.SUCCESS, (state, action: AnyAction) => ({
      ...state,
      options: {...state.options, ...action.payload},
      loaded: true,
    }))
    .addCase(getCheckoutOptions.fulfilled, (state, action) => {
      state.options = {...state.options, ...action.payload}
      state.loaded = true
    })
})
